<template>

    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll"
        class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
        <Column>
            <template #header="">
                <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
            </template>
            <template #body="slotProps">
                <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
            </template>
        </Column>
        <Column field="Role" :header="$t('role')" key="Role" class="w-1">
            <template #body="slotProps">
                <InputText name="Role" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('role')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="rolename" :header="$t('rolename')" key="rolename" class="w-2">
            <template #body="slotProps">
                <InputText name="rolename" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('rolename')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="tempArrL" :header="$t('criticall')" key="tempArrL">
            <template #body="slotProps">
                <CustomMultiSelectV2 v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/userbycompany'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changeL(slotProps, $event);"
                    placeholder="Please Select Approval" :disabled="!canEdit" :params="{ companyId: this.companyId }" />
            </template>
        </Column>
        <Column field="tempArrM" :header="$t('criticalm')" key="tempArrM">
            <template #body="slotProps">
                <CustomMultiSelectV2 v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/userbycompany'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changeM(slotProps, $event)"
                    placeholder="Please Select Approval" :disabled="!canEdit" :params="{ companyId: this.companyId }" />
            </template>
        </Column>
        <Column field="tempArrH" :header="$t('criticalh')" key="tempArrH">
            <template #body="slotProps">
                <CustomMultiSelectV2 v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/userbycompany'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changeH(slotProps, $event)"
                    placeholder="Please Select Approval" :disabled="!canEdit" :params="{ companyId: this.companyId }" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            companyId: this.$store.getters.getCompanyId,
            tempArr: [],
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        changeFuelType(event, e) {
            // this.dataArray[event.index].tempArrL = e == null ? [] : e;
            // console.log(this.tempArr);
            this.dataArray[event.index].userListL = this.dataArray[event.index].tempArrL.map(a => a.id);
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;


            var det = { ...newDetail };


            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;
                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;

                }
            }
        },
        // companychange(event, e) {
        //     if (this.dataArray && this.dataArray.length > 0) {
        //         this.dataArray[event.index].ApproverId = [];
        //     }
        // },
        changeL(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].tempArrL = e == null ? [] : e;
                this.dataArray[event.index].userListL = this.dataArray[event.index].tempArrL.map(a => a.id);
            }
        },
        changeM(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].tempArrM = e == null ? [] : e;
                this.dataArray[event.index].userListM = this.dataArray[event.index].tempArrM.map(a => a.id);
            }
        },
        changeH(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].tempArrH = e == null ? [] : e;
                this.dataArray[event.index].userListH = this.dataArray[event.index].tempArrH.map(a => a.id);
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    }
}
</script>